export const WEEKDAYS = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
] as const;

export type Weekday = typeof WEEKDAYS[number];

export const WEEKDAY_LABELS: Record<Weekday, string> = {
  SUNDAY: 'Sunday',
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
};

interface MeetingLike {
  weekday: string;
  startsAt: string;
  endsAt: string;
}

export function formatClockTime(value: string): string {
  const match = value.match(/^(\d{2}):(\d{2})/);
  if (!match) return value;

  const hours = Number(match[1]);
  const minutes = match[2];
  const suffix = hours >= 12 ? 'PM' : 'AM';
  const displayHour = hours % 12 || 12;
  return `${displayHour}:${minutes} ${suffix}`;
}

export function formatMeeting(meeting: MeetingLike): string {
  const weekday = WEEKDAY_LABELS[meeting.weekday as Weekday] ?? meeting.weekday;
  return `${weekday}, ${formatClockTime(meeting.startsAt)}–${formatClockTime(meeting.endsAt)}`;
}

export function compareMeetings(first: MeetingLike, second: MeetingLike): number {
  const firstDay = WEEKDAYS.indexOf(first.weekday as Weekday);
  const secondDay = WEEKDAYS.indexOf(second.weekday as Weekday);
  if (firstDay !== secondDay) return firstDay - secondDay;

  return first.startsAt.localeCompare(second.startsAt) || first.endsAt.localeCompare(second.endsAt);
}
